export default __webpack_public_path__ + "static/media/WROSE.91616903.svg";